import { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { primaryBtn } from "../styles";
import blob from "../img/blob.svg";
import promoData from "../promoData";

function Promotion({ promotionalData }) {
  const data = promoData();
  const [current, setCurrent] = useState(promoData()[0]);
  const [direction, setDirection] = useState(true);

  const activeButton = {
    color: " #f8f1f1",
    background: "#19456b",
    boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.2)",
  };

  const defaultButton = {
    color: "#19456b",
    background: "#f8f1f1",
    boxShadow: "none",
  };

  const length = data.length;

  const nextSlide = () => {
    setCurrent(
      current.index === length - 1 ? data[0] : data[current.index + 1]
    );
    setDirection(false);
  };

  const prevSlide = () => {
    setCurrent(
      current.index === 0 ? data[length - 1] : data[current.index - 1]
    );
    setDirection(true);
  };

  const slideChangeHandler = (e) => {
    data.forEach((item) => {
      if (e.currentTarget.innerHTML === item.button) {
        setCurrent(item);
      }
    });
  };

  return (
    <Container id="Accounts">
      <MainContainer className="main-container">
        {current && (
          <PromoContainer>
            <div className="blob">
              <img src={blob} alt="blob" />
            </div>
            <div className="blob blob-2">
              <img src={blob} alt="blob" />
            </div>
            <div className="first-container">
              <div className="promo-title">
                <motion.div
                  className="title"
                  key={current.index}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                >
                  <h2>{current.title}</h2>
                </motion.div>

                <div className="desc">
                  <p>{current.desc}</p>
                </div>
                <div className="button">
                  <LearnMore>Learn More</LearnMore>
                </div>

                <div className="arrows">
                  <button onClick={prevSlide} className="arrow-btn">
                    {"<"}
                  </button>
                  <button onClick={nextSlide} className="arrow-btn">
                    {">"}
                  </button>
                </div>
              </div>

              <div className="promo-img">
                <div className="border"></div>

                <motion.img
                  key={current.index}
                  src={current.img}
                  initial={
                    direction === true
                      ? { opacity: 0.5, x: 50 }
                      : { opacity: 0.5, x: -50 }
                  }
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0.5 }}
                  transition={{
                    x: { type: "spring", stiffness: 100 },
                    default: { duration: 0.5 },
                  }}
                  className="image"
                />
              </div>
            </div>
          </PromoContainer>
        )}
      </MainContainer>

      <Selection>
        <div className="s1">
          <h3
            value={data[0].button}
            style={
              data[0].button === current.button ? activeButton : defaultButton
            }
            onClick={slideChangeHandler}
          >
            {data[0].button}
          </h3>
        </div>

        <div className="s2">
          <h3
            value={data[1].button}
            onClick={slideChangeHandler}
            style={
              data[1].button === current.button ? activeButton : defaultButton
            }
          >
            {data[1].button}
          </h3>
        </div>

        <div className="s3">
          <h3
            value={data[2].button}
            onClick={slideChangeHandler}
            style={
              data[2].button === current.button ? activeButton : defaultButton
            }
          >
            {data[2].button}
          </h3>
        </div>
      </Selection>
    </Container>
  );
}

export default Promotion;

const Container = styled(motion.div)`
  margin-top: 7.5rem;
`;

const MainContainer = styled(motion.div)`
  width: 100%;
  flex-direction: column;
  margin: auto;
  position: relative;
  overflow: hidden;

  @media (min-width: 1600px) {
    width: 100rem;
  }
`;

const Selection = styled(motion.div)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  background: #f8f1f1;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);

  @media (max-width: 600px) {
    display: none;
  }

  div {
    width: 100%;
    text-align: center;
    cursor: pointer;
  }

  h3 {
    padding: 1rem 1rem;
  }

  .s1,
  .s2 {
    border-right: solid 1px #19456b;
  }
`;

const PromoContainer = styled(motion.div)`
  min-height: 65vh;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  position: relative;

  padding: 2rem 3rem;

  @media (max-width: 1024px) {
    padding: 0rem;
  }

  @media (min-width: 2000px) {
    min-height: 40rem;
  }

  .blob {
    position: absolute;
    width: 100rem;
    height: 60rem;
    overflow: hidden;
    left: 40rem;
    top: -1rem;
    z-index: -11;

    img {
      width: 100%;
    }

    @media (max-width: 1024px) {
      display: none;
    }
  }

  .blob-2 {
    left: 45rem;
    top: -1rem;

    @media (max-width: 1024px) {
      display: none;
    }
  }

  .first-container {
    position: relative;
    display: flex;
    width: 100%;
  }

  .promo-title {
    display: flex;
    flex-direction: column;
    margin-left: 10rem;
    flex: 1 1 40rem;
    width: 100%;
    flex-wrap: wrap;
    padding-right: 2rem;
    justify-content: center;
    position: relative;

    @media (max-width: 1324px) {
      margin-left: 0rem;
    }

    @media (max-width: 1124px) {
      margin-left: 0rem;
    }

    @media (max-width: 1024px) {
      margin: 0rem 1rem;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-right: 0rem;

      h3,
      h2,
      h4,
      p {
        color: white;
      }
    }

    @media (max-width: 420px) {
      padding: 1rem 0rem;
    }

    div {
      padding: 1rem 0rem;

      @media (max-width: 1024px) {
        h3,
        h2,
        h4,
        p {
          color: white;
        }
      }
    }

    .title {
      font-size: 2rem;

      @media (max-width: 420px) {
        font-size: 1.5rem;
      }
    }

    .desc {
      font-weight: bold;
      font-size: 1.1rem;
      line-height: 1.8rem;

      @media (max-width: 420px) {
        font-size: 1rem;
      }
    }

    .arrows {
      display: flex;
      justify-content: space-between;
      width: 8rem;

      @media (max-width: 400px) {
        padding: 1rem 0rem;
      }
    }

    .arrow-btn {
      font-size: 1.4rem;
      font-weight: 600;
      width: 2rem;
      height: 2rem;
      border: none;
      border-radius: 50rem;
      font-family: "Poppins", sans-serif;
      background: #393939;
    }

    h2,
    p,
    button {
      white-space: normal;
      font-family: "Roboto", sans-serif;
      color: #222222;
    }

    button {
      margin: 0;
      font-size: 1rem;
      color: white;
      background: #19456b;
      box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.4);

      :active {
        box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.3);
      }
    }
  }

  .promo-img {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    flex: 1 1 40rem;
    position: relative;

    @media (max-width: 1024px) {
      position: absolute;
      opacity: 1;
      z-index: -11;
      filter: brightness(40%);
    }

    .border {
      position: absolute;
      width: 40rem;
      height: 100%;
      border-radius: 0.8rem;
      margin-right: 1rem;
      margin-top: 1rem;
      background: #16c79a;
      opacity: 0.5;
      z-index: -10;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

      @media (max-width: 1150px) {
        width: 32rem;
      }

      @media (max-width: 1024px) {
        background: #000000;
        width: 100%;
        border-radius: 0rem;
        opacity: 1;
        margin: 0;
      }
    }

    .image {
      width: 40rem;
      object-fit: cover;
      border-radius: 0.5rem;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      cursor: pointer;

      @media (max-width: 1150px) {
        width: 32rem;
      }

      @media (max-width: 1024px) {
        border-radius: 0rem;
        width: 100%;
      }
    }
  }
`;

const LearnMore = styled(primaryBtn)``;
